<script>
export default {
  name: 'Status',
  inheritAttrs: false,
  props: {
    status: {
      type: Boolean,
      required: true,
    },
    inactiveStyle: {
      type: Object,
      default: () => ({}),
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    title() {
      return this.status ? 'Active' : 'Inactive'
    },
    styleObj() {
      const objStyle = {
        ...this.status && { color: '#0fbd1c' },
        ...(!this.status || !this.enabled) && this.inactiveStyle,
      }
      return objStyle
    },
  },
}
</script>

<template>
  <div
    :class="$style.container"
    :style="styleObj"
  >
    <div :class="$style.badge" />
    {{ title }}
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
}

.badge {
  width: rem(10px);
  height: rem(10px);
  margin-right: rem(10px);
  background-color: currentColor;
  border-radius: 50%;
}
</style>
